<template>
  <div class="reply-mailbox-list" v-loading="loading">
    <div class="mailbox-list-header" v-if="type == 'From'">
      <gj-select
        v-model="readed"
        :options="options"
        :clearable="false"
        class="no-left-border select-readed"
        width="124px"
        :filterable="false"
        @change="changeStatus()"
      >
      </gj-select>
      <el-button
        type="text"
        v-if="type == 'From'"
        style="color: #666666; font-size: 12px"
        @click="outTicketItemReadAll"
        >全标已读</el-button
      >
    </div>
    <div class="mailbox-list-op">
      <el-checkbox
        v-if="false"
        class="reply-left"
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选
      </el-checkbox>
      <span v-else style="color: rgba(153, 153, 153, 1)">
        <span>共</span>
        {{ total }}
        条
      </span>

      <span class="reply-right">
        <span style="color: rgba(102, 102, 102, 1)">{{
          type == 'Drafts' ? '更新日期' : '收件时间'
        }}</span>
        <span
          style="
            cursor: pointer;
            margin-right: 6px;
            display: inline-block;
            transform: translateY(-3px);
          "
        >
          <span style="display: flex; flex-direction: column; color: #c0c4cc" @click="changeSort">
            <i class="el-icon-caret-top" :class="{ high_color: order !== 'descending' }"></i>
            <i
              class="el-icon-caret-bottom"
              :class="{ high_color: order === 'descending' }"
              style="margin-top: -5px"
            ></i>
          </span>
        </span>
      </span>
    </div>
    <template v-if="mailboxList.length">
      <div class="mailbox-list-content">
        <div
          v-for="(item, index) in mailboxList"
          :key="item.outTicketItemId"
          @click="cellHandler(index, item)"
          :class="['cell', { active: item.active }]"
          @mouseover="mouseoverHnadel(index)"
          @mouseleave="mouseLeaveHnadel(index)"
        >
          <template v-if="!item.draftsId">
            <div class="cell-header item-row">
              <el-checkbox
                v-show="false && (item.hasCheckbox || checkAll || isIndeterminate)"
                @change="checkboxChange"
                v-model="item.checked"
                class="reply-left el-checkbox"
              >
              </el-checkbox>
              <span
                style="width: 14px;"
                class="circle-box"
                v-show="!item.hasCheckbox && !checkAll && !isIndeterminate"
              >
                <span class="circle" v-if="item.type === 'From' && item.readed == 'unRead'"></span>
                <el-tooltip class="item" effect="dark" content="发送失败" placement="top-start">
                  <i
                  style="transform: translateY(3px);"
                    class="circle-wraing el-icon-warning"
                    v-if="item.type === 'To' && item.status == 'fail'"
                  ></i>
                </el-tooltip>
              </span>
              <span style="color: rgba(51, 51, 51, 1); font-weight: 500" class="text">{{
                item.buyerName
              }}</span>
              <span style="color: rgba(153, 153, 153, 1)" class="reply-right email-time">{{
                item.simpleEmailTime
              }}</span>
            </div>
            <div class="cell-content item-row">
              <span style="width: 14px"></span>
              <span
                style="
                  color: rgba(102, 102, 102, 1);
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  margin-right:47px
                "
                class="reply-left text "
                >{{ item.subject }}</span
              >
              <span><collectionIcon :collection="item.collection == 0"></collectionIcon></span>
            </div>
          </template>

          <template v-else>
            <div style="display: flex; flex-direction: column; padding-left: 10px">
              <span>
                <span
                  style="
                    margin-bottom: 5px;
                    width: 140px;
                    margin-bottom: 5px;
                    color: rgba(51, 51, 51, 1); font-weight: 500;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                  "
                  >{{
                    item.emailAddressExcelName || item.buyerName || getTilte(item.emailAddress) || '-'
                  }}</span
                >
                  <span
                  style="color: rgba(153, 153, 153, 1); width: 65px"
                  class="reply-right email-time"
                  >
                  {{ item.simpleUpdateTime }}
                  </span>
              </span>
              <span
                style="width: 150px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
                >{{ item.subject }}</span
              >
            </div>
          </template>
        </div>
      </div>
      <div class="el-pagination-class">
        <el-pagination
          :small="true"
          :page-size="size"
          layout="prev, pager, next"
          :total="total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </template>
    <div v-else>
      <gj-empty></gj-empty>
    </div>
  </div>
</template>
<script>
import collectionIcon from './components/collection-icon';
import { outTicketItemReaded, outTicketItemReadAll } from '@/api/crm';

export default {
  name: 'mailbox-list',
  components: { collectionIcon },
  props: {
    emailId: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 20,
    },
    type: {
      type: String,
      default: '',
    },
    mailboxList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        { text: '全部邮件', id: 'all' },
        { text: '已读', id: 'read' },
        { text: '未读', id: 'unRead' },
      ],
      current: 1,
      readed: 'all',
      checked: true,
      checkAll: false,
      isIndeterminate: false,
      order: 'descending',
      index: 0,
    };
  },
  created() {},
  methods: {
    initParams() {
      this.readed = 'all';
      this.current = 1;
      this.order = 'descending';
    },
    outTicketItemReadAll() {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '温馨提示',
          content: `请确定是否全标已读！`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;

            let parms = {
              emailId: this.emailId,
              type: 'From',
            };
            outTicketItemReadAll(parms).then(() => {
              this.$gjMessage.success('操作成功');
              modal.$gjDestroy();
              this.$emit('readAllSuccess');
            });
          },
        },
      });
    },
    changeParmas() {
      this.$emit('changeParmas', {
        readed: this.readed,
        order: this.order,
        current: this.current,
      });
    },
    getTilte(str) {
      let arr = str.split(';');
      return arr.length > 1 ? `${arr[0]}等${arr.length}人` : str;
    },
    currentChange(current) {
      this.current = current;
      this.changeParmas();
    },
    mouseoverHnadel(index) {
      // this.mailboxList[index].hasCheckbox = true
    },
    mouseLeaveHnadel(index) {
      // this.mailboxList[index].hasCheckbox = false
    },
    changeStatus() {
      this.changeParmas();
    },
    changeSort() {
      this.order = this.order === 'descending' ? 'ascending' : 'descending';
      this.changeParmas();
    },
    handleCheckAllChange(value) {
      this.isIndeterminate = false;
      this.mailboxList.forEach((res) => {
        if (value) {
          res.checked = true;
        } else {
          res.checked = false;
        }
      });
    },
    checkboxChange() {
      let checkedNum = 0;
      this.mailboxList.forEach((res) => {
        if (res.checked) checkedNum = checkedNum + 1;
      });
      if (this.mailboxList.length === checkedNum || checkedNum == 0) {
        this.isIndeterminate = false;
        if (checkedNum == 0) {
          this.checkAll = false;
          return;
        }
        this.checkAll = true;
      } else {
        this.isIndeterminate = true;
      }
    },
    // 选中当前项
    cellHandler(index, item) {
      this.mailboxList.forEach((res) => {
        res.active = false;
      });
      if (item.readed === 'unRead' && this.type == 'From') {
        outTicketItemReaded(item.outTicketItemId).then(() => {
          this.$emit('cellHandler', index, item, true);
        });
      } else {
        this.$emit('cellHandler', index, item);
      }
      this.index = index;
    },
  },
};
</script>

<style lang="scss">
.high_color {
  color: #1f6eef;
}
.reply-mailbox-list {
  .select-readed {
    .el-input__inner {
      border: none;
      background: #f8f8f8;
    }
  }
  display: flex;
  flex-direction: column;
  width: 262px;
  box-sizing: border-box;
  padding: 11px 0 0 8px;
  border-right: 1px solid #e4e5e6;
  position: relative;

  .mailbox-list-header {
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 17px;
  }
  .mailbox-list-op {
    margin-bottom: 11px;
    padding: 0 10px;
    height: 15px;
    margin-top: 11px !important;
  }

  .mailbox-list-content {
    width: 100%;
    cursor: pointer;
    flex: 1;
    overflow: auto;
    .circle {
      width: 7px;
      height: 7px;
      display: inline-block;
      background: #1f6eef;
      border-radius: 50%;
    }
    .circle-wraing {
      color: red;
      position: absolute;
      font-size: 12px;
    }
    .fix-none {
      display: none !important;
    }
    .fix-block {
      display: inline-block !important;
    }
    .circle-box {
      position: relative;
      box-sizing: border-box;
    }
    // .cell:hover .circle-box {
    //   display: none;
    // }
    // .el-checkbox {
    //   display: none;
    // }
    // .cell:hover .el-checkbox {
    //   display: inline-block;
    // }
    .active {
      background: #eef3fb !important;
    }
    .cell {
      padding: 8px 10px;
      border-bottom: 1px solid #eeeff0;
      box-sizing: border-box;
      position: relative;
      height: 60px;
      .email-time {
        white-space: nowrap;
      }

      .cell-header {
        height: 25px;
        width: 100%;
      }
      .item-row {
        display: flex;
        flex-direction: row;
      }
      .text {
        width: 153px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // padding: 0 10px;
        margin-left: 8px;
        margin-right: 47px;
      }
      .cell-content {
        height: 19px;
      }

      .triangle {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  .el-pagination-class {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
